import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (
      ![
        /* Examples: 10/03/1993, 10-03-1993 */
        /^(0[1-9]|[12]\d|3[01])[/-](0[1-9]|1[0-2])[/-]\d{4}/,
        /* Examples: 03/10/1993, 03-10-1993 */
        /^(0[1-9]|1[0-2])[/-](0[1-9]|[12]\d|3[01])[/-]\d{4}/,
        /* Examples: 1993/03/10, 1993-03-10 */
        /^(\d{4})[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12]\d|3[01])/,
      ].some((pattern) => pattern.test(control.value))
    ) {
      return {
        invalidDateFormat: true,
      };
    }

    return null;
  };
}
